module.exports = __webpack_public_path__ + "static/media/dsr_finance3.0a8d9df2.svg";